import React, {FC } from 'react'
import {Link} from 'react-router-dom'
import {PATH_CONTACTS} from '../../../../app/routing/paths'

interface Contact {
    email: string
    first_name: string
    last_name: string
    number: string
    id: number
}

const ListsWidget3: FC<{contacts: Contact[] | undefined}> = ({contacts}) => {

    const colors = ['success', 'primary', 'info', 'warning', 'danger']

    return (
        <>
            {/* begin::Header */}
            <div className="card-header border-0">
                <h3 className="card-title fw-bolder text-dark">5 derniers contacts</h3>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className="card-body p-3">
                {
                    contacts?.length ?
                        contacts?.map((contact, index) => (
                            <div className="d-flex align-items-center mb-8" key={index}>
                                {/* begin::Bullet */}
                                <span className={`bullet me-5 bullet-vertical h-40px bg-${colors[index]}`} />
                                {/* end::Bullet */}
                                {/* begin::Description */}
                                <div className="flex-grow-1">
                                    <Link to={`${PATH_CONTACTS.contactEdit}/${contact.id}`}
                                          className="text-gray-800 text-hover-primary fw-bolder fs-7">
                                        {contact.first_name} {contact.last_name}
                                    </Link>
                                    <span className="text-muted fw-bold d-block fs-8">{contact.email}</span>
                                </div>
                                {/* end::Description */}
                                <span
                                    className={`badge badge-light-${colors[index]} fs-9 fw-bolder`}>{contact.number}</span>
                            </div>
                        ))
                        : <h4 className="text-gray-700 fs-5">La liste des 5 derniers contacts est vide</h4>
                }
            </div>
            {/* end::Body */}
        </>
    )
}

export {ListsWidget3}
